import { render, staticRenderFns } from "./RouteOrderSelector.vue?vue&type=template&id=60c5fc2c&scoped=true&"
import script from "./RouteOrderSelector.vue?vue&type=script&lang=js&"
export * from "./RouteOrderSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60c5fc2c",
  null
  
)

export default component.exports